export default "__VITE_ASSET__jfN85FEs__"